<template>
  <div :class="$style.platformPlusMessageArea">
    <div :class="$style.platformPlusMessageIconArea">
      <Icon icon="premiumDiscover" />
    </div>

    <div :class="$style.platformPlusMessageContent">
      <div :class="$style.platformPlusMessageTitle">
        {{ title }}
      </div>

      <div :class="$style.platformPlusMessageBody">
        <p>{{ message }}</p>

        <span
          v-if="linkText"
          :class="$style.platformPlusLinkText"
          data-test-id="learnMoreLink"
          @click="handleClick"
        >
          {{ linkText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import ModalEventBus from 'components/Modal/ModalEventBus';
import PlatformPlusModal from 'client/components/Modal/PlatformPlusModal.vue';

export default {
  name: 'PlatformPlusBadgeCard',

  components: {
    Icon,
  },

  props: {
    features: {
      type: Array,
      required: true,
    },
    linkText: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      required: true,
    },
    pluralFeatureName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleClick() {
      ModalEventBus.open({
        isLargeModal: true,
        component: PlatformPlusModal,
        componentProps: {
          pluralFeatureName: this.pluralFeatureName,
          features: this.features,
        },
      });
    },
  },
};
</script>

<style module>
.platformPlusMessageArea {
  background-color: var(--jcTertiary50);
  border: 1px solid var(--jcTertiary50);
  border-radius: 0.3em;
  display: flex;
}

.platformPlusMessageIconArea {
  padding: 0.5em;
}

.platformPlusMessageIcon {
  align-self: baseline;
  font-size: 1em;
  height: auto;
  width: 1.1em;
}

.platformPlusMessageIcon path {
  fill: var(--jcGrey800);
}

.platformPlusMessageContent {
  padding: 0.5em;
  padding-left: 0;
}

.platformPlusMessageTitle {
  color: var(--jcGrey800);
  font-size: 0.9em;
  margin-bottom: 0.5em;
}

.platformPlusMessageBody p,
.platformPlusMessageBody span {
  color: var(--jcGrey800);
  font-size: 0.75em;
  margin-bottom: 0.5em;
}

.platformPlusLinkText {
  color: var(--jcGrey800);
  cursor: pointer;
  text-decoration: underline;
}

.platformPlusLinkText:hover {
  color: var(--jcGrey800);
}
</style>
